module.exports = __webpack_public_path__ + "img/xiuxian.e656e789.png";